import { Tabs } from "flowbite-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import slide1 from "../../../assets/images/slide1.webp";
import slide2 from "../../../assets/images/slide2.webp";
import slide3 from "../../../assets/images/slide3.webp";

import arrow_left2 from "../../../assets/images/arrow_left2.svg"; // Adjust the path accordingly
import arrow_right2 from "../../../assets/images/arrow_right2.svg"; // Adjust the path accordingly
import { useRef } from "react";

export default function LibraryMobi() {
  const swiperRef = useRef(null); // Define swiperRef here

  const images2024 = [slide1, slide2, slide3]; // Array of images for the 2024 tab

  return (
    <div className="container mx-auto p-3">
      <Tabs aria-label="Default tabs" variant="default">
        <Tabs.Item active title="2024">
          <div className="flex flex-col gap-3 items-center">
            {/*  */}

            {/*  */}
            <div className="border border-[#fafafa] bg-[#fafafa] rounded-[8px] px-[1rem] py-[1rem] mt-4">
              <p className="text-[1.125rem] text-[#1375B7] font-semibold">
                Chào mừng ngày lễ Phụ nữ Việt Nam 20/10
              </p>
              <p className="text-[1rem] font-normal text-[#333333]">10/2024</p>
            </div>
            <div className="relative w-full flex items-center">
              <button
                className="bg-gray-100 p-2 rounded-full shadow-md absolute left-0 z-10"
                onClick={() => swiperRef.current.swiper.slidePrev()}
                aria-label="Previous image"
              >
                <img src={arrow_left2} alt="Left arrow" className="w-4 h-4" />
              </button>

              <Swiper
                ref={swiperRef} // Set the ref to the Swiper instance
                modules={[Navigation]}
                loop={true}
                navigation={false}
                className="swiper-container w-full"
              >
                {images2024.map((img, index) => (
                  <SwiperSlide key={index}>
                    <img
                      src={img}
                      alt={`slide-${index}`}
                      className="object-cover rounded-md shadow w-full"
                    />
                  </SwiperSlide>
                ))}
              </Swiper>

              <button
                className="bg-gray-100 p-2 rounded-full shadow-md absolute right-0 z-10"
                onClick={() => swiperRef.current.swiper.slideNext()}
                aria-label="Next image"
              >
                <img src={arrow_right2} alt="Right arrow" className="w-4 h-4" />
              </button>
            </div>
          </div>
        </Tabs.Item>
        <Tabs.Item title="2023">
          <div>Upload...</div>
        </Tabs.Item>
        <Tabs.Item title="2022">
          <div>Upload...</div>
        </Tabs.Item>
        <Tabs.Item title="2021">
          <div>Upload...</div>
        </Tabs.Item>
        <Tabs.Item title="2020">
          <div>Upload...</div>
        </Tabs.Item>
      </Tabs>
    </div>
  );
}
